import { LANGUAGE_DEFAULT } from '@src/configs/const.config'
import { ELanguage, TDataInitTranslation } from '@src/configs/interface.config'

import vi from '../../assets/languages/vi.png'
import en from '../../assets/languages/en.png'
import ja from '../../assets/languages/japan.svg'

export function referValueTranslation(data: TDataInitTranslation, field: string, lang = LANGUAGE_DEFAULT) {
  return data.translation?.[lang]?.[field] || data.translation?.[LANGUAGE_DEFAULT]?.[field] || data?.[field]
}

export function generateUrlFlagLang(code: ELanguage) {
  switch (code) {
    case ELanguage.VI:
      return vi
    case ELanguage.EN:
      return en
    case ELanguage.JA:
      return ja
    default:
      return vi
  }
}
